import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import barnyardRedux from 'barnyard/redux';
import rootReducer from './rootReducer';
import routes from './routes';

// Configure our history and store
const store = barnyardRedux.store(rootReducer);
const history = syncHistoryWithStore(browserHistory, store);

export default class AccountsApp extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router
          history={history}
          routes={routes}
        />
      </Provider>
    );
  }
}
